import { UserLocaleService } from '@miq/platform';
import { IUser, userGroupEnum } from '../../models/user.model';

const USER_INFO_STORAGE_KEY = 'userInfo';
const UK_COUNTRIES = ['UK', 'United Kingdom', 'GB', 'GBR', 'United Kingdom of Great Britain and Northern Irl', 'Great Britain'];

const userLocaleService = new UserLocaleService();

const getUserInfoFromStorage = (): IUser | null => {
  try {
    const raw = localStorage.getItem(USER_INFO_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/**
 * Returns a function that evaluates if a given user contains a given user group
 */
export const hasUserGroup =
  (targetGroup: userGroupEnum) =>
  (user: IUser): boolean =>
    (user.groups ?? []).some(group => group.value === targetGroup);

/** Returns whether a given user has VAS Approver group */
export const hasVASApproverGroup = hasUserGroup(userGroupEnum.VAS_APPROVER);

/** Returns whether a given user is based in a CE (Central Europe) country */
export const isCEUser = (user: IUser): boolean => userLocaleService.isEURCEUser(user.userCountrySkey);

export const isCENotVASApprover = (user: IUser): boolean => isCEUser(user) && !hasVASApproverGroup(user);

/** No-arg version — reads current user from localStorage */
export const isCENotVASApproverFromStorage = (): boolean => {
  const user = getUserInfoFromStorage();
  return user ? isCENotVASApprover(user) : false;
};

/** Returns whether the current SSO user is from United Kingdom */
export const isUKUserFromStorage = (): boolean => {
  const user = getUserInfoFromStorage();
  return user ? UK_COUNTRIES.includes(user.userCountry) : false;
};

export const enum vasApprovalFlag {
  verified = 'Verified',
  rejected = 'Rejected',
  toBeVerified = 'To Be Verified',
}
